import { render, staticRenderFns } from "./satisfaction.vue?vue&type=template&id=af01fb00"
import script from "./satisfaction.vue?vue&type=script&lang=js"
export * from "./satisfaction.vue?vue&type=script&lang=js"
import style0 from "./satisfaction.vue?vue&type=style&index=0&id=af01fb00&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports